module.exports = __webpack_public_path__ + "static/media/Glaceon_gaussian2.259534d1.png";